import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import Button from 'flarum/common/components/Button';
import Tooltip from 'flarum/common/components/Tooltip';
import LinkButton from 'flarum/common/components/LinkButton';
import SelectDropdown from 'flarum/common/components/SelectDropdown';
import ConfirmPurchaseModal from './ConfirmPurchaseModal';
// CSS-value sanitizer for admin-controlled `Group->color` strings, which are
// rendered inside `style="background:..."` attributes. Without this, a value
// like `red;background-image:url(//evil/x)` would inject arbitrary CSS into
// every shop render. Allowlist mirrors what a CSS <color> token can hold
// (hex, rgb()/rgba()/hsl()/hsla()/named tokens) — anything else returns empty.
function sanitizeCssColor(raw) {
  if (typeof raw !== 'string') return '';
  const s = raw.trim();
  if (s.length === 0 || s.length > 64) return '';
  return /^(#[0-9a-fA-F]{3,8}|(?:rgb|rgba|hsl|hsla)\([^)]*\)|[a-zA-Z]+)$/.test(s) ? s : '';
}
export default class ShopPage extends Page {
  constructor() {
    super(...arguments);
    _defineProperty(this, "loading", false);
    _defineProperty(this, "claiming", new Set());
  }
  // Active tab is derived from the route param `tab` so that each section has
  // its own URL (/rewards/name, /rewards/cover, /rewards/tiers). The bare
  // `/rewards` path falls back to 'avatar' below.
  get tab() {
    const raw = m.route.param('tab');
    const valid = ['avatar', 'name', 'cover', 'title', 'post-hl', 'tiers'];
    if (valid.includes(raw)) return raw;

    // Bare /rewards → pick the first enabled family so the user lands on
    // a populated tab instead of an empty "avatar" page that admins
    // disabled. Master toggles flip each family on/off independently.
    const attr = k => app.forum.attribute(k) !== false;
    if (attr('pointSystem.avatar_deco_enabled')) return 'avatar';
    if (attr('pointSystem.name_deco_enabled')) return 'name';
    if (attr('pointSystem.cover_deco_enabled')) return 'cover';
    if (attr('pointSystem.title_deco_enabled')) return 'title';
    if (attr('pointSystem.post_hl_deco_enabled')) return 'post-hl';
    return 'tiers';
  }
  oninit(vnode) {
    super.oninit(vnode);
    // Permission gate — users without `pointSystem.viewShop` get a 404-style
    // page. The nav entry is already hidden for them, but they could still
    // reach this URL by typing it or following an old link.
    if (!app.forum.attribute('pointSystemCanViewShop')) return;
    const title = app.translator.trans('ramon-point-system.forum.shop.title');
    app.history.push('shop', title);
    app.setTitle(title);
  }
  view() {
    var _user$attribute, _user$attribute2;
    if (!app.forum.attribute('pointSystemCanViewShop')) {
      return m("div", {
        className: "PointSystemShop-notFound container"
      }, m("h1", null, "404"), m("p", null, app.translator.trans('ramon-point-system.forum.shop.not_found')));
    }
    const user = app.session.user;
    const items = this.tab === 'avatar' ? this.avatarItems() : this.tab === 'name' ? this.nameItems() : this.tab === 'cover' ? this.coverItems() : this.tab === 'title' ? this.titleItems() : this.tab === 'post-hl' ? this.postHlItems() : [];
    const tiers = app.forum.attribute('pointSystemGroupOffers') || [];
    const avatarEnabled = app.forum.attribute('pointSystem.avatar_deco_enabled') !== false;
    const nameEnabled = app.forum.attribute('pointSystem.name_deco_enabled') !== false;
    const coverEnabled = app.forum.attribute('pointSystem.cover_deco_enabled') !== false;
    const titleEnabled = app.forum.attribute('pointSystem.title_deco_enabled') !== false;
    const postHlEnabled = app.forum.attribute('pointSystem.post_hl_deco_enabled') !== false;
    return m("div", {
      className: "PointSystemShop"
    }, m("div", {
      className: "PointSystemShop-header container"
    }, m("h1", null, app.translator.trans('ramon-point-system.forum.shop.title')), m("p", {
      className: "PointSystemShop-subtitle"
    }, app.translator.trans('ramon-point-system.forum.shop.subtitle')), user && m("div", {
      className: "PointSystemShop-balance"
    }, m("span", {
      className: "PointSystemShop-balance-item"
    }, m("i", {
      className: app.forum.attribute('pointSystem.currency_icon') || 'fas fa-coins'
    }), m("span", null, app.translator.trans('ramon-point-system.forum.shop.your_balance'), ":", ' ', m("strong", null, Number((_user$attribute = user.attribute('pointBalance')) != null ? _user$attribute : 0).toLocaleString()))), app.forum.attribute('pointSystem.lifetime_enabled') !== false && m("span", {
      className: "PointSystemShop-balance-item PointSystemShop-balance-item--lifetime"
    }, m("i", {
      className: "fas fa-chart-line"
    }), m("span", null, app.translator.trans('ramon-point-system.forum.shop.lifetime'), ":", ' ', m("strong", null, Number((_user$attribute2 = user.attribute('pointLifetime')) != null ? _user$attribute2 : 0).toLocaleString()))), m(LinkButton, {
      href: app.route('pointSystem.decorations'),
      icon: "fas fa-tshirt",
      className: "Button Button--link"
    }, app.translator.trans('ramon-point-system.forum.shop.my_decorations')))), m("nav", {
      className: "PointSystemShop-nav App-titleControl"
    }, m(SelectDropdown, {
      className: "PointSystemShop-nav-select",
      buttonClassName: "Button",
      accessibleToggleLabel: app.translator.trans('ramon-point-system.forum.shop.toggle_nav_label')
    }, this.navItems(avatarEnabled, nameEnabled, coverEnabled, titleEnabled, postHlEnabled, tiers.length > 0))), this.tab === 'tiers' ? this.renderTiers(user) : m("div", {
      className: "container"
    }, items.length === 0 ? m("div", {
      className: "PointSystemShop-empty"
    }, app.translator.trans('ramon-point-system.forum.shop.empty')) : m("div", {
      className: "PointSystemShop-grid PointSystemShop-grid--".concat(this.tab)
    }, items.map(it => this.renderCard(it)))));
  }
  navItems(avatarEnabled, nameEnabled, coverEnabled, titleEnabled, postHlEnabled, hasTiers) {
    // Bind explicitly — destructuring `app.translator.trans` loses the `this`
    // reference and trips `preprocessTranslation` on the default theme.
    const t = app.translator.trans.bind(app.translator);
    const current = this.tab;
    const item = (id, icon, label) => {
      const isActive = current === id;
      const href = app.route('pointSystem.shop.tab', {
        tab: id
      });
      return m(LinkButton, {
        className: "Button Button--link",
        icon: icon,
        href: href,
        active: isActive,
        itemClassName: isActive ? 'active' : ''
      }, label);
    };
    return [avatarEnabled ? item('avatar', 'fas fa-user-circle', t('ramon-point-system.forum.shop.tab_avatar')) : null, nameEnabled ? item('name', 'fas fa-font', t('ramon-point-system.forum.shop.tab_name')) : null, coverEnabled ? item('cover', 'fas fa-image', t('ramon-point-system.forum.shop.tab_cover')) : null, titleEnabled ? item('title', 'fas fa-id-badge', t('ramon-point-system.forum.shop.tab_title')) : null, postHlEnabled ? item('post-hl', 'fas fa-highlighter', t('ramon-point-system.forum.shop.tab_post_hl')) : null, hasTiers ? item('tiers', 'fas fa-layer-group', t('ramon-point-system.forum.shop.tab_tiers')) : null];
  }
  renderTiers(user) {
    var _user$attribute3, _user$attribute4, _user$groups;
    const offers = app.forum.attribute('pointSystemGroupOffers') || [];
    if (!offers.length) {
      return m("div", {
        className: "container"
      }, m("div", {
        className: "PointSystemShop-empty"
      }, app.translator.trans('ramon-point-system.forum.shop.tiers_empty')));
    }
    const balance = Number((_user$attribute3 = user == null ? void 0 : user.attribute('pointBalance')) != null ? _user$attribute3 : 0);
    const lifetime = Number((_user$attribute4 = user == null ? void 0 : user.attribute('pointLifetime')) != null ? _user$attribute4 : 0);
    const userGroupIds = new Set(((user == null || (_user$groups = user.groups) == null ? void 0 : _user$groups.call(user)) || []).filter(Boolean).map(g => Number(g.id())));
    return m("div", {
      className: "container PointSystemShop-tiers"
    }, m("p", {
      className: "PointSystemShop-subtitle"
    }, app.translator.trans('ramon-point-system.forum.shop.tiers_help')), m("div", {
      className: "PointSystemShop-tiersGrid"
    }, offers.map(o => this.renderOffer(o, user, balance, lifetime, userGroupIds))));
  }
  renderOffer(offer, user, balance, lifetime, userGroupIds) {
    const isAuto = offer.isAuto !== false;
    const isPurchasable = !!offer.isPurchasable;
    const threshold = Number(offer.pointsRequired || 0);
    const price = Number(offer.price || 0);
    const owned = user && userGroupIds.has(Number(offer.groupId));
    const qualifiedByLifetime = isAuto && lifetime >= threshold;
    const canBuy = user && isPurchasable && balance >= price;
    const claimKey = "tier:".concat(offer.id);
    const isClaiming = this.claiming.has(claimKey);
    const currencyIcon = app.forum.attribute('pointSystem.currency_icon') || 'fas fa-coins';
    const reached = qualifiedByLifetime || canBuy;
    const progress = user && isAuto && threshold > 0 ? Math.min(100, Math.max(0, Math.round(lifetime / threshold * 100))) : 0;
    return m("div", {
      className: "PointSystemShop-tier ".concat(reached ? 'is-reached' : '', " ").concat(owned ? 'is-owned' : ''),
      key: offer.id
    }, m("div", {
      className: "PointSystemShop-tier-badge",
      style: sanitizeCssColor(offer.groupColor) ? "background:".concat(sanitizeCssColor(offer.groupColor)) : undefined
    }, m("i", {
      className: offer.groupIcon || 'fas fa-medal'
    })), m("div", {
      className: "PointSystemShop-tier-body"
    }, m("div", {
      className: "PointSystemShop-tier-name"
    }, offer.groupName || '—'), isAuto && m("div", {
      className: "PointSystemShop-tier-points PointSystemShop-tier-points--threshold"
    }, m("i", {
      className: "fas fa-bolt"
    }), " ", Number(threshold).toLocaleString(), ' ', app.translator.trans('ramon-point-system.forum.shop.tier_threshold')), isPurchasable && m("div", {
      className: "PointSystemShop-tier-points PointSystemShop-tier-points--price"
    }, m("i", {
      className: currencyIcon
    }), " ", Number(price).toLocaleString(), " ", app.translator.trans('ramon-point-system.forum.shop.tier_buy_cost')), user && !owned && isAuto && threshold > 0 && !qualifiedByLifetime && m("div", {
      className: "PointSystemShop-tier-progressBar"
    }, m("span", {
      style: "width:".concat(progress, "%")
    }))), m("div", {
      className: "PointSystemShop-tier-action"
    }, user && owned && m(Button, {
      className: "Button Button--primary PointSystemShop-equippedBtn",
      disabled: true
    }, m("i", {
      className: "fas fa-check"
    }), " ", app.translator.trans('ramon-point-system.forum.shop.tier_claimed')), user && !owned && qualifiedByLifetime && m(Button, {
      className: "Button Button--primary",
      loading: isClaiming,
      onclick: () => this.confirmClaimOffer(offer, 'auto')
    }, m("i", {
      className: "fas fa-bolt"
    }), " ", app.translator.trans('ramon-point-system.forum.shop.tier_claim')), user && !owned && !qualifiedByLifetime && isPurchasable && canBuy && m(Button, {
      className: "Button Button--primary",
      loading: isClaiming,
      onclick: () => this.confirmClaimOffer(offer, 'purchase')
    }, m("i", {
      className: "fas fa-coins"
    }), " ", app.translator.trans('ramon-point-system.forum.shop.tier_buy')), user && !owned && !qualifiedByLifetime && (!isPurchasable || !canBuy) && m(Button, {
      className: "Button",
      disabled: true
    }, isPurchasable && !canBuy ? app.translator.trans('ramon-point-system.forum.shop.tier_not_enough') : app.translator.trans('ramon-point-system.forum.shop.tier_locked'))));
  }
  async claimTier(offer, mode) {
    if (mode === void 0) {
      mode = 'purchase';
    }
    const key = "tier:".concat(offer.id);
    this.claiming.add(key);
    m.redraw();
    try {
      const apiUrl = String(app.forum.attribute('apiUrl') || '/api').replace(/\/+$/, '');
      const res = await app.request({
        method: 'POST',
        url: "".concat(apiUrl, "/point-system/tier-claim"),
        body: {
          id: offer.id,
          mode
        }
      });
      const user = app.session.user;
      if (user) {
        var _data;
        const existing = (((_data = user.data) == null || (_data = _data.relationships) == null || (_data = _data.groups) == null ? void 0 : _data.data) || []).slice();
        if (!existing.find(g => String(g.id) === String(offer.groupId))) {
          existing.push({
            type: 'groups',
            id: String(offer.groupId)
          });
          user.pushData({
            relationships: {
              groups: {
                data: existing
              }
            }
          });
        }
        const data = (res == null ? void 0 : res.data) || res;
        if ((data == null ? void 0 : data.balance) !== undefined) {
          user.pushAttributes({
            pointBalance: Number(data.balance)
          });
        }
      }
      app.alerts.show({
        type: 'success'
      }, app.translator.trans('ramon-point-system.forum.shop.tier_claimed_alert', {
        name: offer.groupName
      }));
    } catch (e) {
      var _e$response;
      const detail = (e == null || (_e$response = e.response) == null || (_e$response = _e$response.errors) == null || (_e$response = _e$response[0]) == null ? void 0 : _e$response.detail) || app.translator.trans('ramon-point-system.forum.shop.tier_claim_failed');
      app.alerts.show({
        type: 'error'
      }, detail);
    } finally {
      this.claiming.delete(key);
      m.redraw();
    }
  }
  coverItems() {
    return this.shoppable('pointSystemCoverDecorations', 'cover_decoration');
  }
  titleItems() {
    return this.shoppable('pointSystemTitleDecorations', 'title_decoration');
  }
  postHlItems() {
    return this.shoppable('pointSystemPostHighlightDecorations', 'post_highlight_decoration');
  }

  // Shop tabs only render items the user could conceivably buy right now:
  // - isAvailable === false items (disabled / expired / sold-out / wrong group)
  //   stay in the payload because the user MIGHT own them and need them on
  //   the My Decorations page — but the shop grid filters them out so they
  //   don't appear as "buyable".
  // - Items the user already owns DO stay visible (rendered as "Equipped" or
  //   "Equip" CTAs) so they can reach the equip flow from the shop tab.
  shoppable(attribute, type) {
    const raw = app.forum.attribute(attribute) || [];
    return raw.filter(d => d.isAvailable !== false || this.userOwnsId(type, d.id)).map(d => _objectSpread(_objectSpread({}, d), {}, {
      type
    }));
  }
  userOwnsId(type, id) {
    var _app$session$user;
    const list = ((_app$session$user = app.session.user) == null ? void 0 : _app$session$user.attribute('ownedDecorationIds')) || [];
    return list.some(o => o.type === type && Number(o.id) === Number(id));
  }
  renderCard(item) {
    var _user$attribute5, _app$translator$trans;
    const user = app.session.user;
    const balance = Number((_user$attribute5 = user == null ? void 0 : user.attribute('pointBalance')) != null ? _user$attribute5 : 0);
    const owned = this.userOwns(item);
    const equipped = this.userEquipped(item);
    const canAfford = balance >= item.price;
    const claimKey = "".concat(item.type, ":").concat(item.id);
    const isClaiming = this.claiming.has(claimKey);
    const badges = this.availabilityBadges(item);
    const cardCls = ['PointSystemShop-card', "PointSystemShop-card--".concat(item.type.replace(/_decoration$/, '').replace(/_/g, '-')), item.isAnimated ? 'is-animated' : '', owned ? 'is-owned' : '', equipped ? 'is-equipped' : ''].filter(Boolean).join(' ');
    return m("div", {
      className: cardCls
    }, equipped && m("div", {
      className: "PointSystemShop-card-equippedRibbon"
    }, m("i", {
      className: "fas fa-check-circle"
    }), " ", app.translator.trans('ramon-point-system.forum.shop.equipped_label')), badges.length > 0 && m("div", {
      className: "PointSystemShop-card-badges"
    }, badges), m("div", {
      className: "PointSystemShop-card-preview"
    }, item.type === 'avatar_decoration' ? this.previewAvatar(item) : item.type === 'cover_decoration' ? this.previewCover(item) : item.type === 'title_decoration' ? this.previewTitle(item) : item.type === 'post_highlight_decoration' ? this.previewPostHl(item) : this.previewName(item)), m("div", {
      className: "PointSystemShop-card-body"
    }, m("h3", {
      className: "PointSystemShop-card-title"
    }, item.name), item.description && m("p", {
      className: "PointSystemShop-card-desc"
    }, item.description), item.creatorUsername && m("a", {
      className: "PointSystemShop-card-creator",
      href: app.route.user({
        slug: item.creatorUsername
      }),
      title: String((_app$translator$trans = app.translator.trans('ramon-point-system.forum.shop.creator_tooltip', {
        name: item.creatorDisplayName || item.creatorUsername
      })) != null ? _app$translator$trans : '')
    }, item.creatorAvatarUrl ? m("img", {
      className: "PointSystemShop-card-creatorAvatar",
      src: item.creatorAvatarUrl,
      alt: ""
    }) : m("span", {
      className: "PointSystemShop-card-creatorAvatar PointSystemShop-card-creatorAvatar--placeholder"
    }, m("i", {
      className: "fas fa-user"
    })), m("span", null, app.translator.trans('ramon-point-system.forum.shop.by_creator', {
      name: item.creatorDisplayName || item.creatorUsername
    }))), m("div", {
      className: "PointSystemShop-card-price"
    }, m("i", {
      className: app.forum.attribute('pointSystem.currency_icon') || 'fas fa-coins'
    }), m("strong", null, item.price.toLocaleString())), !user && m(Tooltip, {
      text: app.translator.trans('ramon-point-system.forum.shop.must_login')
    }, m("span", {
      style: "display: inline-block"
    }, m(Button, {
      className: "Button",
      disabled: true
    }, app.translator.trans('ramon-point-system.forum.shop.login_to_claim')))), user && equipped && m(Button, {
      className: "Button Button--primary PointSystemShop-equippedBtn",
      disabled: true
    }, m("i", {
      className: "fas fa-check"
    }), " ", app.translator.trans('ramon-point-system.forum.shop.equipped')), user && owned && !equipped && m(Button, {
      className: "Button Button--primary",
      loading: isClaiming,
      onclick: () => this.equip(item)
    }, m("i", {
      className: "fas fa-bolt"
    }), " ", app.translator.trans('ramon-point-system.forum.shop.equip')), user && !owned && m(Button, {
      className: "Button Button--primary",
      disabled: !canAfford,
      loading: isClaiming,
      onclick: () => this.confirmClaim(item)
    }, canAfford ? app.translator.trans('ramon-point-system.forum.shop.claim') : app.translator.trans('ramon-point-system.forum.shop.not_enough'))));
  }
  userEquipped(item) {
    var _user$attribute0;
    const user = app.session.user;
    if (!user) return false;
    if (item.type === 'avatar_decoration') {
      var _user$attribute6;
      return Number((_user$attribute6 = user.attribute('equippedAvatarDecorationId')) != null ? _user$attribute6 : 0) === Number(item.id);
    }
    if (item.type === 'cover_decoration') {
      var _user$attribute7;
      return Number((_user$attribute7 = user.attribute('equippedCoverDecorationId')) != null ? _user$attribute7 : 0) === Number(item.id);
    }
    if (item.type === 'title_decoration') {
      var _user$attribute8;
      return Number((_user$attribute8 = user.attribute('equippedTitleDecorationId')) != null ? _user$attribute8 : 0) === Number(item.id);
    }
    if (item.type === 'post_highlight_decoration') {
      var _user$attribute9;
      return Number((_user$attribute9 = user.attribute('equippedPostHighlightDecorationId')) != null ? _user$attribute9 : 0) === Number(item.id);
    }
    return Number((_user$attribute0 = user.attribute('equippedNameDecorationId')) != null ? _user$attribute0 : 0) === Number(item.id);
  }
  previewAvatar(item) {
    var _app$session$user2, _app$session$user2$av;
    const src = item.imageUrl || item.imagePath || '';
    const url = src ? this.resolveAsset(src) : '';
    const userAvatarUrl = (_app$session$user2 = app.session.user) == null || (_app$session$user2$av = _app$session$user2.avatarUrl) == null ? void 0 : _app$session$user2$av.call(_app$session$user2);
    return m("div", {
      className: "PointSystemShop-avatarPreview"
    }, userAvatarUrl ? m("img", {
      className: "PointSystemShop-avatarPreview-img",
      src: userAvatarUrl,
      alt: ""
    }) : m("span", {
      className: "PointSystemShop-avatarPreview-placeholder",
      "aria-hidden": "true"
    }, m("i", {
      className: "fas fa-user"
    })), url && m("img", {
      className: "PointSystemShop-avatarPreview-frame",
      src: url,
      alt: ""
    }));
  }
  previewCover(item) {
    const src = item.imageUrl || item.imagePath || '';
    const url = src ? this.resolveAsset(src) : '';
    return m("div", {
      className: "PointSystemShop-coverPreview"
    }, url ? m("img", {
      src: url,
      alt: item.name
    }) : m("div", {
      className: "PointSystemShop-coverPreview-empty"
    }));
  }
  previewName(item) {
    var _app$session$user3, _app$session$user3$us;
    const slug = String(item.slug || '').replace(/[^a-zA-Z0-9_-]/g, '');
    const username = ((_app$session$user3 = app.session.user) == null || (_app$session$user3$us = _app$session$user3.username) == null ? void 0 : _app$session$user3$us.call(_app$session$user3)) || 'Username';
    return m("div", {
      className: "PointSystemShop-namePreview"
    }, m("span", {
      className: "ps-name-preview ps-name-".concat(slug)
    }, username));
  }
  previewTitle(item) {
    const slug = String(item.slug || '').replace(/[^a-zA-Z0-9_-]/g, '');
    const text = String(item.titleText || item.name || '—');
    const safeColor = sanitizeCssColor(item.color);
    const styleVar = safeColor ? "--ps-title-color:".concat(safeColor, ";") : '';
    return m("div", {
      className: "PointSystemShop-titlePreview"
    }, m("span", {
      className: "ps-title-preview ps-title-".concat(slug),
      style: styleVar
    }, text));
  }
  previewPostHl(item) {
    const slug = String(item.slug || '').replace(/[^a-zA-Z0-9_-]/g, '');
    return m("div", {
      className: "PointSystemShop-postHlPreview"
    }, m("div", {
      className: "ps-posthl-preview ps-posthl-".concat(slug)
    }, m("div", {
      className: "ps-posthl-preview-avatar"
    }), m("div", {
      className: "ps-posthl-preview-body"
    }, m("div", {
      className: "ps-posthl-preview-line"
    }), m("div", {
      className: "ps-posthl-preview-line short"
    }))));
  }
  avatarItems() {
    return this.shoppable('pointSystemAvatarDecorations', 'avatar_decoration');
  }
  nameItems() {
    return this.shoppable('pointSystemNameDecorations', 'name_decoration');
  }
  userOwns(item) {
    var _app$session$user4;
    const list = ((_app$session$user4 = app.session.user) == null ? void 0 : _app$session$user4.attribute('ownedDecorationIds')) || [];
    return list.some(o => o.type === item.type && Number(o.id) === Number(item.id));
  }

  // Build "limited stock" + "time-limited" badges for a shop card. Items the
  // user already owns skip these — the badges are buyer-facing context, not
  // owner-facing. Disabled items also skip (the card is rendered for the
  // equip flow, not for purchase context).
  availabilityBadges(item) {
    if (item.isAvailable === false) return [];
    if (this.userOwns(item)) return [];
    const badges = [];
    const t = app.translator.trans.bind(app.translator);
    if (item.maxClaims != null && item.maxClaims > 0) {
      const remaining = Math.max(0, Number(item.maxClaims) - Number(item.claimCount || 0));
      const cls = remaining <= Math.max(5, Math.floor(item.maxClaims * 0.1)) ? 'is-warning' : '';
      badges.push(m("span", {
        className: "PointSystemShop-card-badge ".concat(cls)
      }, m("i", {
        className: "fas fa-box"
      }), " ", t('ramon-point-system.forum.shop.badge_remaining', {
        count: remaining
      })));
    }
    if (item.availableUntil) {
      const remainingMs = new Date(item.availableUntil).getTime() - Date.now();
      if (remainingMs > 0) {
        const days = Math.ceil(remainingMs / (24 * 60 * 60 * 1000));
        const hours = Math.ceil(remainingMs / (60 * 60 * 1000));
        const label = days >= 2 ? t('ramon-point-system.forum.shop.badge_ends_in_days', {
          count: days
        }) : t('ramon-point-system.forum.shop.badge_ends_in_hours', {
          count: Math.max(1, hours)
        });
        const cls = days <= 1 ? 'is-warning' : '';
        badges.push(m("span", {
          className: "PointSystemShop-card-badge ".concat(cls)
        }, m("i", {
          className: "fas fa-hourglass-half"
        }), " ", label));
      }
    }
    if (item.availableFrom && new Date(item.availableFrom).getTime() > Date.now()) {
      const dateLabel = new Date(item.availableFrom).toLocaleDateString();
      badges.push(m("span", {
        className: "PointSystemShop-card-badge is-future"
      }, m("i", {
        className: "fas fa-calendar"
      }), " ", t('ramon-point-system.forum.shop.badge_starts_on', {
        date: dateLabel
      })));
    }
    return badges;
  }
  confirmClaim(item) {
    var _user$attribute1;
    const user = app.session.user;
    if (!user) return;
    const balance = Number((_user$attribute1 = user.attribute('pointBalance')) != null ? _user$attribute1 : 0);
    const preview = item.type === 'avatar_decoration' ? this.previewAvatar(item) : item.type === 'cover_decoration' ? this.previewCover(item) : this.previewName(item);
    app.modal.show(ConfirmPurchaseModal, {
      title: app.translator.trans('ramon-point-system.forum.confirm.title'),
      itemName: item.name,
      itemPrice: item.price,
      currentBalance: balance,
      preview,
      confirmLabel: app.translator.trans('ramon-point-system.forum.shop.claim'),
      onConfirm: () => this.claim(item)
    });
  }
  confirmClaimOffer(offer, mode) {
    var _user$attribute10;
    const user = app.session.user;
    if (!user) return;
    const balance = Number((_user$attribute10 = user.attribute('pointBalance')) != null ? _user$attribute10 : 0);
    const isAuto = mode === 'auto';
    const cost = isAuto ? 0 : Number(offer.price || 0);
    const preview = m("div", {
      className: "PointSystemShop-tier-badge",
      style: sanitizeCssColor(offer.groupColor) ? "background:".concat(sanitizeCssColor(offer.groupColor)) : undefined
    }, m("i", {
      className: offer.groupIcon || 'fas fa-medal'
    }));
    app.modal.show(ConfirmPurchaseModal, {
      title: app.translator.trans(isAuto ? 'ramon-point-system.forum.confirm.title_tier' : 'ramon-point-system.forum.confirm.title_purchase'),
      itemName: offer.groupName || '—',
      itemPrice: cost,
      currentBalance: balance,
      preview,
      confirmLabel: app.translator.trans(isAuto ? 'ramon-point-system.forum.shop.tier_claim' : 'ramon-point-system.forum.shop.tier_buy'),
      onConfirm: () => this.claimTier(offer, mode)
    });
  }
  async claim(item) {
    const user = app.session.user;
    if (!user) {
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('ramon-point-system.forum.shop.must_login'));
      return;
    }
    const key = "".concat(item.type, ":").concat(item.id);
    this.claiming.add(key);
    m.redraw();
    try {
      var _user$attribute11;
      const apiUrl = String(app.forum.attribute('apiUrl') || '/api').replace(/\/+$/, '');
      await app.request({
        method: 'POST',
        url: "".concat(apiUrl, "/point-system/claim/").concat(item.id),
        body: {
          type: item.type
        }
      });

      // Optimistically update local state
      const owned = user.attribute('ownedDecorationIds') || [];
      owned.push({
        type: item.type,
        id: item.id
      });
      user.pushAttributes({
        ownedDecorationIds: owned,
        pointBalance: Math.max(0, Number((_user$attribute11 = user.attribute('pointBalance')) != null ? _user$attribute11 : 0) - item.price)
      });
      app.alerts.show({
        type: 'success'
      }, app.translator.trans('ramon-point-system.forum.shop.claimed', {
        name: item.name
      }));
    } catch (e) {
      var _e$response2;
      const detail = (e == null || (_e$response2 = e.response) == null || (_e$response2 = _e$response2.errors) == null || (_e$response2 = _e$response2[0]) == null ? void 0 : _e$response2.detail) || app.translator.trans('ramon-point-system.forum.shop.claim_failed');
      app.alerts.show({
        type: 'error'
      }, detail);
    } finally {
      this.claiming.delete(key);
      m.redraw();
    }
  }
  async equip(item) {
    const user = app.session.user;
    if (!user) {
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('ramon-point-system.forum.shop.must_login'));
      return;
    }
    const key = "".concat(item.type, ":").concat(item.id);
    this.claiming.add(key);
    m.redraw();
    try {
      const apiUrl = String(app.forum.attribute('apiUrl') || '/api').replace(/\/+$/, '');
      await app.request({
        method: 'POST',
        url: "".concat(apiUrl, "/point-system/equip"),
        body: {
          type: item.type,
          id: item.id
        }
      });
      // Update local cache so the rest of the UI re-renders with the new deco
      if (item.type === 'avatar_decoration') {
        user.pushAttributes({
          equippedAvatarDecorationId: item.id,
          // Remote-hosted frames carry `imageUrl` and no `imagePath`; using
          // `imagePath` alone left the optimistic frame blank until a reload.
          // Mirror DecorationsPage.equip's `imageUrl || imagePath` fallback.
          equippedAvatarDecorationUrl: item.imageUrl || item.imagePath
        });
      } else if (item.type === 'cover_decoration') {
        user.pushAttributes({
          equippedCoverDecorationId: item.id,
          equippedCoverDecorationUrl: item.imageUrl || item.imagePath
        });
      } else if (item.type === 'title_decoration') {
        user.pushAttributes({
          equippedTitleDecorationId: item.id,
          equippedTitleDecorationSlug: item.slug,
          equippedTitleDecorationText: item.titleText
        });
      } else if (item.type === 'post_highlight_decoration') {
        user.pushAttributes({
          equippedPostHighlightDecorationId: item.id,
          equippedPostHighlightDecorationSlug: item.slug
        });
      } else {
        user.pushAttributes({
          equippedNameDecorationId: item.id,
          equippedNameDecorationSlug: item.slug
        });
      }
      app.alerts.show({
        type: 'success'
      }, app.translator.trans('ramon-point-system.forum.shop.equipped_alert', {
        name: item.name
      }));
    } catch (e) {
      var _e$response3;
      const detail = (e == null || (_e$response3 = e.response) == null || (_e$response3 = _e$response3.errors) == null || (_e$response3 = _e$response3[0]) == null ? void 0 : _e$response3.detail) || app.translator.trans('ramon-point-system.forum.shop.equip_failed');
      app.alerts.show({
        type: 'error'
      }, detail);
    } finally {
      this.claiming.delete(key);
      m.redraw();
    }
  }
  resolveAsset(path) {
    if (!path) return '';
    if (/^https?:\/\//i.test(path)) return path;
    const base = app.forum.attribute('assetsBaseUrl') || app.forum.attribute('baseUrl') + '/assets';
    return base.replace(/\/+$/, '') + '/' + String(path).replace(/^\/+/, '');
  }
}
flarum.reg.add('ramon-point-system', 'forum/components/ShopPage', ShopPage);